import { collection, doc, getDoc, getDocs, limit, query, where } from "firebase/firestore";
import { db } from "./firebase";

export interface TenantConfig {
  id: string;
  slug: string;
  displayName?: string;
  status?: "active" | "inactive";
  modules?: Record<string, boolean>;
  branding?: {
    logoUrl?: string;
    primaryColor?: string;
    secondaryColor?: string;
    loginTitle?: string;
    loginSubtitle?: string;
  };
}

export const getTenantBySlug = async (slug: string): Promise<TenantConfig | null> => {
  const normalized = (slug || "").trim().toLowerCase();
  if (!normalized) return null;

  const byIdRef = doc(db, "tenants", normalized);
  const byIdSnap = await getDoc(byIdRef);
  if (byIdSnap.exists()) {
    return { id: byIdSnap.id, ...(byIdSnap.data() as Omit<TenantConfig, "id">) };
  }

  const q = query(collection(db, "tenants"), where("slug", "==", normalized), limit(1));
  const snap = await getDocs(q);
  if (snap.empty) return null;

  const first = snap.docs[0];
  return { id: first.id, ...(first.data() as Omit<TenantConfig, "id">) };
};

export const isTenantMember = async (tenantId: string, uid: string): Promise<boolean> => {
  if (!tenantId || !uid) return false;

  const byCompositeRef = doc(db, "tenantMembers", `${tenantId}_${uid}`);
  const byCompositeSnap = await getDoc(byCompositeRef);
  if (byCompositeSnap.exists()) {
    const data = byCompositeSnap.data() as any;
    return (data?.status || "active") === "active";
  }

  const q = query(
    collection(db, "tenantMembers"),
    where("tenantId", "==", tenantId),
    where("uid", "==", uid),
    limit(1),
  );
  const snap = await getDocs(q);
  if (snap.empty) return false;

  const data = snap.docs[0].data() as any;
  return (data?.status || "active") === "active";
};
